module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/glyphicons-halflings-regular.eot
// module id = x8aS
// module chunks = 1